import isNil from "lodash/isNil";
import toString from "lodash/toString";

import type { i18n } from "@similarweb/i18n-provider";

const getPrimarySiteName = (): string => {
    try {
        const hash = window.location.hash;
        const urlParams = new URLSearchParams(hash.includes("?") ? hash.split("?")[1] : "");
        const keyParam = urlParams.get("key");

        if (keyParam) {
            const primarySite = keyParam.split(",")[0];
            return primarySite.startsWith("*") ? primarySite.substring(1) : primarySite;
        }

        const pathSegments = hash.replace("#/", "").split("/");
        for (const segment of pathSegments) {
            if (segment.includes(".") && !segment.includes("=") && !segment.includes("?")) {
                return segment.startsWith("*") ? segment.substring(1) : segment;
            }
        }

        return "";
    } catch (e) {
        return "";
    }
};

export const customInterpolation = (i18nextInstance: i18n): i18n => {
    const debug = document.cookie.indexOf("locale_debug=1") !== -1;
    const replacements: Record<string, () => string> = {
        site: getPrimarySiteName,
    };
    const replacementKeys = Object.keys(replacements);
    /**
     * main i18n function
     * @param key
     * i18n key
     * @param data
     * interpolation data map: map keys that appear as %key% in the target string, will be interpolated.
     * interpolation data value can be a string, or a function (for deferred values)
     * @returns {string}
     */
    const interpolate = (key: string, data?: any): string => {
        // Normalize key to lowercase to ensure consistency with translation files
        // This handles cases where keys might be passed with mixed or uppercase letters
        const normalizedKey = key && typeof key === "string" ? key.toLowerCase() : key;
        let s = (debug ? "[" + normalizedKey + "] " : "") + (i18nextInstance.t(normalizedKey, data) || "");
        if (data && s && s.indexOf("%") > -1) {
            for (const key in data) {
                if (!data.hasOwnProperty(key)) {
                    continue;
                }

                const value = data[key];
                let text = "";
                if (isNil(value)) {
                    text = "";
                } else if (typeof value === "function") {
                    text = value();
                } else {
                    text = toString(value);
                }
                s = s.replace(new RegExp("%" + key + "%", "g"), text);
            }
        }
        replacementKeys.forEach((replacement) => {
            const searchString = `%${replacement}%`;

            if (s && s.indexOf(searchString) > -1) {
                s = s.replace(searchString, replacements[replacement]());
            }
        });
        return s;
    };

    return {
        ...i18nextInstance,
        t: interpolate,
    };
};
